import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { RegistrationApi, type RegisterCompleteRequest } from '@shared/api';

const registerCompleteEffect = createEffect((request: RegisterCompleteRequest) => RegistrationApi.registerComplete(request));
const clearEvent = createEvent();

const $dataStore = createStore<boolean>(false)
  .on(registerCompleteEffect.done, (_, data) => data.result.success)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(registerCompleteEffect.pending, (_, data) => data)
  .on(registerCompleteEffect.fail, () => false)
  .on(registerCompleteEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(registerCompleteEffect, () => null)
  .on(registerCompleteEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(registerCompleteEffect.done, () => null)
  .reset(clearEvent);

export const $registerCompleteStore = {
  events: {
    registerComplete: registerCompleteEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
